import React,{useState,useEffect} from 'react';
import {Box,LinearProgress,//IconButton,Typography
    IconButton,Tooltip,FormControl,InputLabel,Select, Button,
    MenuItem,TextField,FormControlLabel,Checkbox,
    Typography} from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import SearchIcon from '@material-ui/icons/Search';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import TablaEstruct from './TablaEstructura';
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import ModalNvoEdit from './ModalNvo';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CardTotal from './CardTotal';

export default function PublicoReg(){
 
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ;  
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;      
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const usuDto =localStorage.getItem('UsuDto') ;
    const usuMun =localStorage.getItem('UsuMun') ;
    const usuSec =localStorage.getItem('UsuSec') ;
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'      
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);     
    const [listMuni,setListMuni] = useState([]);            
    const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});
    const [fSelect2, setFSelect2] = useState({inicio:new Date(),final:new Date()});
    const [actualizar,setActualizar]=useState(true);
    const [espera,setEspera]=useState(false);
    const [espera2,setEspera2]=useState(false);
    const [afiliado,setAfiliado]=useState({muni:0, secc:0,fecha:true,cadena:""});
    const [filtro,setFiltro]=useState({distrito:0, otb:0, barrio:0});
    const [listAfil,setListAfil]=useState([])
    const [munId,setMunId] = useState(null)
    const [seccId,setSeccId] = useState("")
    const [munSelect,setMunSelect] = useState([])    
    const [listAvance, setListAvance]=useState([]);
    const [listPart, setListPart]=useState([]);    
    const [modalNvo, setModalNvo] = useState(false);    
    const [listDto, setListDto]=useState([]); 
    const [listOtb, setListOtb]=useState([]); 
    const [listBarrioOrig, setListBarrioOrig]=useState([]);
    const [listBarrio, setListBarrio]=useState([]);
    const{muni, secc, fecha, cadena}=afiliado
    const{distrito, otb, barrio}=filtro
    const {inicio,final}=fSelect  
    //const drawerWidth = 125;
    useEffect(()=>{             
        const autenticado = authUser();
        if(!autenticado){
            localStorage.clear();
            history.push("/");
            guardarUsuario([])
        }
        else
        {   const usu= localStorage.getItem('UsuarioNom');                 
            if (usuario.length===0) 
            {
                guardarUsuario({Nombre:usu,nivel:nvl});      
                                                     
            }      
            
     
            
            if (listPart.length===0) 
            {   llamadaListPartido()  
            }
            
            getLisAvance()
            getDatos()
                        
            guardarGenerales({...generales,Titulo:'Público'})      
                
        }
        
        return ()=> {
            source.cancel();
        }      
    //la siguiente linea puede generar errores o no en el useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
 
    const funcActualizar=( )=>{       
        getDatos()
        //getLisAvance()         
    }

 

    const getDatos = () => {   
        const auxF1 =moment(fSelect.inicio).format('YYYY-MM-DD')+"T00:00:00"           
        const auxF2 =moment(fSelect.final).format('YYYY-MM-DD')+"T23:59:59"   
        setFSelect2(fSelect)        
        const data = qs.stringify({            
            Usuario:auxId,
            Status:0,
            Estado:0,
            Municipio:0,
            Seccion:0,                        
            FIni:auxF1,
            FFin:auxF2,
            Cadena:""     ,
            idDispositivo: auxDispV,
        });
        const url = "perfil/publico/promovido/filtro";
        function respuesta(aux) {
            if (aux[0].Id!== -1 && aux[0].Id!== 0&& aux[0].Id!== "0")
            {   setListAfil(aux)
            }
            else{
                setListAfil([])
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };

    function getLisAvance()  {            
        const url= `perfil/publico/promovido/filtro`;                            
        const data = qs.stringify({                
            Usuario:auxId,                  
            
            idDispositivo:auxDispV,
        });
                 
        function respuesta (aux) 
        {   if (aux[0].Id !== -1) 
            {                                                    
                setListAvance(aux[0])
            }                                                            
        }
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    };

    function llamadaListPartido()  {            
        const auxU= `partido-base-list`;                            
        const dataInfo = qs.stringify({                
            usuario:auxId,                          
            idDispositivo:auxDispV,
            });
                 
        function respuesta (aux) 
        {   if (aux[0].Id !== -1) 
            {                                                    
                setListPart(aux)
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };

    const generarLista = e =>{   
        e.preventDefault()    
        setActualizar(!actualizar)       
    }

    const guardarInicio = auxfecha =>
    {
        setFSelect({...fSelect, inicio : auxfecha })
    };

    const guardarFinal = auxfecha =>
    {
        setFSelect({ ...fSelect, final : auxfecha })
    };

 
 
    const onChangeSel=(e)=>{
        if (e!== null && e!== undefined) 
        {  setFiltro({...filtro,[e.target.name] : e.target.value})
        }else
        {   setFiltro({...filtro,[e.target.name] : 0})
        } 
        
    }

 
    const handleChange = () => {
        setAfiliado({...afiliado,fecha:!fecha} )
    };
 
    const onChange = e =>
    {         
        const expNopermitida = new RegExp('[._:$!%-({})/*|]');
        const expMenos = new RegExp('-');
        const expMas = new RegExp('[+]');     
        const expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) 
            && !expMas.test(e.target.value)) || e.target.value===' '||e.target.value==='') 
        {
            setAfiliado({
                ...afiliado, 
                [e.target.name] : e.target.value  
            })
        }
    };

    const Reloj =()=>{
    return<MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>    
        <Box component="span" mt={1} >
        <Box  ml={1}  component="span" width={1/4}>                                                
            <DatePicker
                disableFuture format="dd/MM/yyyy"
                views={["year", "month", "date"]}
                label="Fecha Inicial" size="small"
                minDate="2021-12-31" maxDate={new Date()}
                value={inicio} onChange={guardarInicio}      
                style={{width:6.5+'rem'}} cancelLabel={"Cancelar"}                  
                okLabel="Seleccionar" disabled={!fecha}
            />
        </Box>    
        <Box ml={1}  component="span" width="25%">
            <DatePicker
                disableFuture id="final" disabled={!fecha}
                format="dd/MM/yyyy" label="Fecha Final"
                views={["year", "month", "date"]}
                minDate={inicio} maxDate={new Date()}
                value={final} name="final" cancelLabel={"Cancelar"}  
                size="small" style={{width:6.5+'rem'}}      
                okLabel="Seleccionar"  onChange={guardarFinal}
                minDateMessage={"La fecha final debe ser menor a Fecha inicial"}
            />
        </Box> 
    </Box>                         
    </MuiPickersUtilsProvider>
    }
    const auxmodNvo = modalNvo ? 
    <ModalNvoEdit modalAbierto={modalNvo} setModalAbierto={setModalNvo} getDatos={funcActualizar}
        titulo="Nuevo Registro"     
        listPart={listPart}       
    />:null

    const contenido=()=>{
        return(
        <Box display={'flex'} flexDirection="column" >
             
            <Box mb={1} display={"flex"} flexDirection={"row"}>    
            {auxmodNvo}             
                <Button onClick={funcActualizar} style={{width:"7rem", marginRight:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color, height:"2.5rem", marginTop:"1rem"}} 
                    size='small' variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
                    Buscar     
                </Button>
   
          
                {Reloj()}
                {/*  listDto.length!==0 ?                
                    <Box display={"flex"} mt={2} ml={1}>
                    <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select  size='small' variant="outlined"    
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={distrito} onChange={onChangeDto}
                        >
                            <MenuItem size='small' value={0} key={1}>
                                <em>{`Sin Asignar`}</em>
                            </MenuItem>
                            {listDto.map((dto, index) => {
                                
                                return(
                                <MenuItem size='small' value={dto.Id} key={dto.Id +1}>
                                    <em>{dto.cadena }</em>
                                </MenuItem>
                                )
                            } )}                    
                        </Select>
                        </FormControl>
                        </Box>
                    :   null */
                }
                { /* listOtb.length!==0 ?                
                    <Box display={"flex"} mt={2}  >
                    <FormControl size='small'  style={{ minWidth:14+'rem', marginLeft:".5rem"}} >
                        <InputLabel size='small' variant="outlined" id="Otb-label-nvo">OTB</InputLabel>
                        <Select  size='small' variant="outlined"  
                            label="OTB" id="Otb-select2" name="otb"
                            value={otb} onChange={onChangeSel}
                        >
                            <MenuItem size='small' value={0} key={1}>
                                <em>{`Sin Asginar`}</em>
                            </MenuItem>
                            {listOtb.map((secc, index) => {
                                if(secc.Id>0) {
                                return(
                                <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                    <em>{`${secc.Numero} - ${secc.Nom}` }</em>
                                </MenuItem>
                                )}
                            } )}                    
                        </Select>
                        </FormControl>
                    </Box>
                :   null */
                }
                {/* listBarrio.length!==0 ?
                    <Box mt={2} ml={1}>
                    <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Barrio-label-nvo">Zona/Barrio</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '18rem'}}
                            label="Zona/Barrio" id="Barrio-select2" name="barrio"
                            value={barrio} onChange={onChangeSel}
                            fullWidth
                        >
                            <MenuItem size='small' value={0} key={1}>
                                <em>{`Sin Asginar`}</em>
                            </MenuItem>
                            {listBarrio.map((zona, index) => {
                                return (
                                <MenuItem size='small' value={zona.Id} key={zona.Id+1}>
                                    <em>{zona.Nom}</em>
                                </MenuItem>
                                )
                                }
                            )}
                        </Select>
                    </FormControl>    
                    </Box>                                
                :null */}
            </Box>      
                
            <Box>
                {espera ?
                <Box width={"40rem"} ml={2} mt={2}><LinearProgress/></Box>
                : <TablaEstruct muni={listAfil}    fSelect={fSelect2}
                    listPart={listPart} //listTipo={listTipo}  
                    getDatos={funcActualizar}    
                />}
            </Box>
              
        </Box>)
    }

    return (
    <Box display="flex" flexDirection="row" style={{ marginLeft:'1rem'}} >        
        {listPart.length!==0 ? 
            (contenido) 
        :  (<Box pt={1} sx={{width:'100%'}}><LinearProgress/> </Box>)
        }              
    </Box>
    )
}
 